import _systemsAvailable from "./SystemsAvailable";
import _systemsUnavailable from "./SystemsUnavailable";

export const SystemsAvailable = _systemsAvailable;
export const SystemsUnavailable = _systemsUnavailable;
